import React from 'react'

import SimpleAnchor from '../../../components/display/SimpleAnchor'
import BaseFAQ from '../../../components/landing/FAQ'

const faqItems = [
  {
    title: 'What kind of properties can I list?',
    content: (
      <>
        We’re looking for unique accommodation in non-urban areas with beautiful
        nature and outdoor activities nearby. See our{' '}
        <SimpleAnchor
          href="http://help.riparide.com/en/articles/5765492-listing-criteria"
          textDecoration="none"
        >
          listing criteria
        </SimpleAnchor>{' '}
        for more details and our locations.
      </>
    ),
  },
  {
    title: 'What are your fees?',
    content:
      'We charge nothing to list with us. Our host service fee is 2% and our customer service fee is 14.5%. Depending on your location, you can choose to cover the customer fee as well to simplify your pricing.',
  },
  {
    title: 'Can I be listed on other accommodation sites too?',
    content:
      'Of course! While we’d love you to be exclusively Riparide, we know that isn’t always an option. To help you manage your bookings across multiple platforms, we can easily sync your calendars.',
  },
  {
    title:
      'I’m already fully booked on another site - why should I list with Riparide?',
    content:
      'Good question. The answer? We have lower fees, we’re locally-minded and we only work with rad people who share our values. Give us a chance to get you fully booked with Riparide instead!',
  },
  {
    title: 'Do you sync with channel managers?',
    content:
      'Some, but only ones with iCal support at this stage. You can sync all your individual booking platforms though to keep your calendar up to date.',
  },
  {
    title: 'How do I get a Riparide Story for my property?',
    content: (
      <>
        When you create your listing, just add a Story Offer and we’ll work to
        match you with your perfect storyteller. Learn more about{' '}
        <SimpleAnchor href="/stories-hosts" textDecoration="none">
          Riparide Stories.
        </SimpleAnchor>
      </>
    ),
  },
]

const FAQ = () => <BaseFAQ heading="Question Time" items={faqItems} />

export default FAQ
